import { render, staticRenderFns } from "./LgFinderLocalArmazenamento.vue?vue&type=template&id=6556dff6"
import script from "./LgFinderLocalArmazenamento.vue?vue&type=script&lang=js"
export * from "./LgFinderLocalArmazenamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports